/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContrattoResDto } from '../../models/contratto-res-dto';
import { UpdateContrattoDto } from '../../models/update-contratto-dto';

export interface ContrattiControllerUpdateContratto$Params {
  idContratto: number;
  body: UpdateContrattoDto;
}

export function contrattiControllerUpdateContratto(
  http: HttpClient,
  rootUrl: string,
  params: ContrattiControllerUpdateContratto$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContrattoResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    contrattiControllerUpdateContratto.PATH,
    'patch',
  );
  if (params) {
    rb.path('idContratto', params.idContratto, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContrattoResDto>;
      }),
    );
}

contrattiControllerUpdateContratto.PATH = '/admin/contratti/id/{idContratto}';
